import { requestGet, requestPost, requestPut, requestDelete } from '../request'
import apiPath from './apiPath'

const api = {
  CreateModifierItem(payload) {
    return requestPost(apiPath.MODIFIER_ITEM.path, payload)
  },

  GetOneModifierItem(modifierItemID) {
    return requestGet(`${apiPath.MODIFIER_ITEM.path}/${modifierItemID}`)
  },

  GetAllModifierItem(paging, sorting, filtering) {
    return requestGet(apiPath.MODIFIER_ITEM.path, {
      page: paging.page,
      size: paging.size,
      sortBy: sorting.byField,
      sortDir: sorting.isDesc ? 'asc' : 'desc',
      f_outletCode: filtering.outletCode,
      f_modifierGroupCode: filtering.modifierGroupCode,
      f_modifierItemCode: filtering.modifierItemCode,
      f_sequence: filtering.sequence,
      f_isTaxable: filtering.isTaxable,
      f_isActive: filtering.isActive,
      f_isCD: filtering.isCD
    })
  },

  UpdateModifierItem(modifierItemID, payload) {
    return requestPut(
      `${apiPath.MODIFIER_ITEM.path}/${modifierItemID}`,
      payload
    )
  },

  DeleteModifierItem(modifierItemID) {
    return requestDelete(`${apiPath.MODIFIER_ITEM.path}/${modifierItemID}`)
  }
}

export default api
